import * as angular from 'angular';
import {IController} from "angular";

export class ProgramTemplateDetailsViewCtrl implements IController {

  selectedProgramId: string;

  public currentNavItem: any;

  /* @ngInject */
  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.name;
  }

  changeState(stateName) {
    this.$state.go('^.' + stateName, {programId: this.selectedProgramId}, {notify: true, reload: false});
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programTemplateDetailsView', {
    bindings : {
      selectedProgramId: '<'
    },
    template: require('./program-template-details-view.html').default,
    controller : ProgramTemplateDetailsViewCtrl
  });
